<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @new-item="openCreateModal"
                            @delete-items="deleteItems"
                            @row-click="openCreateModal"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:start_date" slot-scope="row">
                                {{row.item.start_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:end_date" slot-scope="row">
                                {{row.item.end_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:active" slot-scope="row">
                                {{row.item.active ? "Active" : "Inactive"}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
            <b-modal :no-close-on-backdrop="true"
                id="modal-Create"
                :title="modals.create.title" hide-footer :centered="true"
                v-model="modals.create.open">
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-dropdown
                                label="Client Contract"
                                vLabel="contract_name"
                                :filterable="false"
                                :required="true"
                                @search="searchContract"
                                :disabled="!!modals.create.data.id"
                                :reduce="contract => contract.id"
                                v-model="modals.create.data.contract_id"
                                :options="modals.create.contract.data">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-dropdown
                                label="Select by Name or Email"
                                desc="Search by name or email"
                                :getOptionLabel="getLabelUserDropdown"
                                @search="searchUser"
                                @change="selectUser"
                                :filterable="false"
                                :required="true"
                                :disabled="!!modals.create.data.id"
                                v-model="modals.create.data.user"
                                :options="modals.create.users.data">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-properties
                                label="Property"
                                :contract-id="modals.create.data.contract_id"
                                v-model="modals.create.data.property"
                                valueFormat="object"
                                required
                                search-nested
                                placeholder="Select"
                                ref="input"
                                :multiple="true"
                                >
                            </gofix-form-properties>
                        </b-col>
                        <b-col md="12" >
                            <gofix-form-tree
                                label="Service Category"
                                :default-expand-level="1"
                                :multiple="true"
                                :flat="true"
                                :options="modals.create.service_categorys"
                                :load-options="loadOptionServices"
                                :normalizer="normalizer"
                                search-nested
                                valueFormat="object"
                                v-model="modals.create.data.service_category"
                                placeholder="Select"
                                ref="input">
                            </gofix-form-tree>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-dropdown
                                :label="modals.create.data.id ? 'Role' : 'Roles'"
                                vLabel="name"
                                :filterable="false"
                                :multiple="!modals.create.data.id"
                                :clearable="!modals.create.data.id"
                                :required="true"
                                :reduce="option => option.id"
                                :disabled="!!modals.create.data.id"
                                v-model="modals.create.data.role_id"
                                :options="modals.create.roles">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-date
                                v-model="modals.create.data.start_date"
                                label="Start Date">
                            </gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-date
                                v-model="modals.create.data.end_date"
                                label="End Date">
                            </gofix-form-input-date>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button v-if="this.modals.create.data.id && this.$checkRole(this.$accessModule.user_duty, 'delete')" label="DELETE" @click="modals.delete.open=true" :loading="modals.delete.loading" noBorder></gofix-button>
                    <gofix-button label="SUBMIT" @click="saveData" :loading="modals.create.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
            <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.delete.open">
                <div class="center">The user duty will be deleted!<br>Do you want to proceed?</div>
                <b-button-group class="btn-group">
                    <b-button class="custom-btn" @click="modals.delete.open = false">Cancel</b-button>
                    <b-button class="custom-btn" :loading="modals.delete.loading" @click="deleteUserDuty">Confirm</b-button>
                </b-button-group>
            </b-modal>
        </div>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';
    import moment from 'moment';

    export default {
        name: 'user-duty',
        data() {
            let filter = JSON.parse(JSON.stringify(filters['contract_user_duty']));
            return {
                tableConfig:{
                    name: 'account-user-duty',
                    controls:{
                        create: this.$checkRole(this.$accessModule.user_duty, 'create'),
                        delete: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "contract_name",
                    sortDirection: "asc"
                },
                tableItems: [],
                modals:{
                    create:{
                        open: false,
                        loading: false,
                        title: "Assign Duties",
                        data: {
                            id: null,
                            user: null,
                            user_id: null,
                            role_id: null,
                            start_date: null,
                            end_date: null,
                            property_id: null,
                            property: null,
                            service_category_id: null,
                            service_category: null,
                            contract_id: null,
                            type: "FM Officer"
                        },
                        contract:{
                            data:[],
                            timer: null
                        },
                        users:{
                            data:[],
                            timer: null
                        },
                        properties: [],
                        roles: [],
                        service_categorys: [],
                        allow_multiple: false
                    },
                    delete:{
                        open:false,
                        loading:false,
                        data:{
                            user_id:null,
                            contract_id:null,
                            role_id:null
                        }
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            }),
        },
        watch: {
            "modals.create.data.contract_id" : function(val,old){
                this.getLocaltion(old);
                this.loadRootServiceCategory()
            },
        },
        created() {
            this.getFMUsers();
            this.getLocaltion();
            this.loadContract();
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.user_type.value = 'FM Officer';
                await this.$store.dispatch("UserDutyController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("UserDutyController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'user_duty'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            searchUser (search, loading){
                loading(true);
                if(this.modals.create.users.timer) {
                    clearTimeout(this.modals.create.users.timer);
                    this.modals.create.users.timer = null;
                }
                this.modals.create.users.timer = setTimeout(() => {
                    this.$store.dispatch("v2UserController/searchListUser", {page:1, totalPage : 0, limit:1000, filters:{ name: search, or: true, email: search, organization_isfm : true}})
                        .then(response => {
                            this.modals.create.users.data = response.data
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            getFMUsers(){
                this.$store.dispatch("v2UserController/searchListUser", {page:1, totalPage : 0, limit:100, filters:{ name: '', organization_isfm : true }})
                    .then(result=>{
                        this.modals.create.users.data = result.data
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            searchFMUser (search, loading){
                loading(true);
                if(this.modals.create.users.timer) {
                    clearTimeout(this.modals.create.users.timer);
                    this.modals.create.users.timer = null;
                }
                this.modals.create.users.timer = setTimeout(() => {
                    this.$store.dispatch("v2UserController/searchListUser", {page:1, totalPage : 0, limit:1000, filters:{ name: search, or: true, email: search, organization_isfm : true }})
                        .then(response => {
                            this.modals.create.users.data = response.data
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            getLocaltion(refreshProperty = true) {
                this.modals.create.properties = [];
                // if(refreshProperty){
                //     this.modals.create.data.property = null;
                // }
                let contract_id = this.modals.create.data.contract_id || (this.ClientContractID ? this.ClientContractID.id : null);
                if(contract_id){
                    global.axios(`api/contracts/${contract_id}/tree-properties/0`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    }).then(response => {
                        this.modals.create.properties = response.data.data;
                    })
                    .catch(error => reject(error));
                }
            },
            loadContract(){
                this.$store.dispatch('ContractController/getListClientContractsSearch', [1, null, 100])
                    .then(response => {
                        this.modals.create.contract.data = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                        this.modals.create.contract.data = [];
                    });
            },
            searchContract(search, loading){
                this.modals.create.contract.data = []
                loading(true);
                if(this.modals.create.contract.timer) {
                    clearTimeout(this.modals.create.contract.timer);
                    this.modals.create.contract.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch('ContractController/getListClientContractsSearch', [1, {contract_name: search }, 1000])
                        .then(response => {
                            this.modals.create.contract.data = response.data
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            async deleteUserDuty(){
                this.modals.delete.loading = true;
                if(!this.modals.delete.data)
                    return this.$alertNotification("Please select a contract,user,role", "danger");

                this.$store.dispatch("UserDutyController/deleteMutilItems", this.modals.delete.data)
                .then(response => {
                    this.modals.delete.loading = false;
                    this.modals.delete.open = false;
                    this.modals.create.open = false;
                    this.$alertNotification(this.$notificationV2('deleting', 'user_duty'));
                    this.$refs.gofixTable.reloadTableItems();
                })
                .catch(err =>{
                    this.modals.delete.loading = false;
                    this.modals.delete.open = false;
                    //reject(err);
                });
            },
            async openCreateModal(item){
                this.modals.delete.data = null;
                if(!item){
                    this.modals.create.title = "Assign Duties";
                    this.modals.create.allow_multiple = true;
                    this.modals.create.data = {
                        id: null,
                        user: null,
                        user_id: null,
                        role_id: null,
                        start_date: null,
                        end_date: null,
                        property_id: null,
                        property: null,
                        service_category_id: null,
                        service_category: null,
                        contract_id: this.ClientContractID ? this.ClientContractID.id : null,
                        type: "FM Officer"
                    }
                }else{
                    if(!this.$checkRole(this.$accessModule.user_duty, 'update')) return;
                    let params_detail = {
                        user_id : item.user_id,
                        contract_id : item.contract_id,
                        role_id : item.role_id
                    };
                    this.modals.delete.data = Object.assign({}, params_detail);
                    let properties_mutil = null, service_category_mutil = null;
                    await this.$store.dispatch(`UserDutyController/getUserDutyDetail`, params_detail)
                        .then(result => {
                            if(result && result.property.length > 0){
                                properties_mutil = result.property;
                            }
                            if(result && result.service_category.length > 0){
                                service_category_mutil = result.service_category;
                            }
                            /*if(result && result.role_id){
                                roles_mutil = result.role_id;
                            }*/
                        })
                        .catch(error => {});
                    //
                    this.modals.create.title = "Edit Duties";
                    this.modals.create.allow_multiple = false;
                    this.modals.create.data = {
                        id: item.id,
                        user: {
                            id: item.user_id,
                            name:item.user_name,
                            email:item.user_email,
                        },
                        user_id: item.user_id,
                        role_id: item.role_id,
                        start_date: item.start_date ? moment(item.start_date).toDate() : null,
                        end_date: item.end_date ? moment(item.end_date).toDate() : null,
                        type: "FM Officer",
                        property_id:  null,
                        property: properties_mutil,
                        service_category_id: null,
                        service_category: service_category_mutil,
                        contract_id: item.contract_id,
                    };
                    // Get role user
                    this.getUserDetail(item.user_id)
                    .then(result => {
                        if(result && result.roles) {
                            this.modals.create.roles = result.roles
                        } else {
                            this.modals.create.roles = [{
                                id: item.role_id,
                                name:item.role_name,
                            }]
                        }
                    })
                }
                this.modals.create.open = true;
            },
            selectUser(item){
                if(item){
                    this.modals.create.roles = item.roles;
                    if(this.modals.create.data.id){
                        this.modals.create.data.role_id = null;
                    }else{
                        this.modals.create.data.role_id = item.roles.map(x => x.id);
                    }
                }else{
                    this.modals.create.roles = [];
                    this.modals.create.data.role_id = null;
                }
            },
            saveData() {
                if(!this.modals.create.data.id && !this.modals.create.data.user) return this.$alertNotification("Please select a user", "danger");
                if(!this.modals.create.data.role_id) return this.$alertNotification("Please select a role", "danger");
                if(!this.modals.create.data.contract_id) return this.$alertNotification("Please select a contract", "danger");
                if(!this.modals.create.data.property || (this.modals.create.data.property && this.modals.create.data.property.length == 0)) return this.$alertNotification("Please select a property", "danger");
                if(!this.modals.create.data.service_category  || (this.modals.create.data.service_category && this.modals.create.data.service_category.length == 0)) return this.$alertNotification("Please select a service category", "danger");
    
                if(this.modals.create.loading) return;
                this.modals.create.loading = true;
                let request = JSON.parse(JSON.stringify(this.modals.create.data));
                request.user_id = request.user ? request.user.id : null;
                //request.service_category_id = request.service_category ? request.service_category.id : null;
                request.start_date = request.start_date ? moment(request.start_date).format("YYYY-MM-DD") : null;
                request.end_date = request.end_date ? moment(request.end_date).format("YYYY-MM-DD") : null;
                let action = 'createItem';
                let keyMsg = 'adding'
                if(this.modals.create.data.id){
                    action = 'updateMutilItem';
                    keyMsg = 'editing'
                    //request.property_id = request.property ? request.property.id : null;
                    request.property_id = request.property.map(x => x.id);
                    request.service_category_id = request.service_category.map(x => x.id);
                } else {
                    request.property_id = request.property.map(x => x.id);
                }
                this.modals.create.loading = false;
                this.modals.create.open = false;

                if(this.modals.create.data.id){
                    //request.service_category_id = request.service_category ? request.service_category.id : null;
                } else {
                    request.service_category_id = request.service_category.map(x => x.id);
                }
                this.$store.dispatch(`UserDutyController/${action}`, request)
                    .then(result => {
                        this.modals.create.loading = false;
                        this.modals.create.open = false;
                        if(this.modals.create.allow_multiple){
                            var messages = result.map(x => x.message);
                            const h = this.$createElement;
                            var tags = [];
                            for(var i=0; i< result.length; i++){
                                var item = result[i];
                                var textTag = null;
                                if(item.error){
                                    textTag = h('li', {style: { color: 'red' } }, ''+item.message);
                                }
                                else{
                                    textTag = h('li', {style: { color: 'green' } }, ''+item.message);
                                }
                                tags.push(textTag);
                            }

                            const vNodesMsg = h(
                            'ul',
                            { class: ['text-left', 'mb-0'] },
                              tags
                            )
                            
                            this.$bvToast.toast([vNodesMsg], {
                            title: 'Notification',
                            solid: true,
                            variant: 'info',
                            autoHideDelay: 10000
                            });
                        }
                        else {
                            this.$alertNotification(this.$notificationV2(keyMsg, 'user_duty'));
                        }

                        this.$store.dispatch("AuthController/getRoles");
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.modals.create.loading = false;
                        this.$alertNotification(error.response.data.error.message.error, "danger", "Duplicate entry validation");
                    });
            },
            getLabelUserDropdown(option){
                if (typeof option === 'object') {
                    return option["name"] + " - " + option["email"]
                }
                return option;
            },
            exportItems() {
                let request = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
                request.limit = -1;
                this.$store.dispatch( 'UserDutyController/exportItems', request)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'user-duty.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            },
            normalizer(node) {
                if (node.data.isBatch)
                    return {
                        id: node.data.id,
                        label: node.text,
                        children: node.children,
                    };
                return {
                    id: node.data.id,
                    label: node.text,
                    children: undefined
                };
            },
            loadRootServiceCategory(){
                this.modals.create.service_categorys = [];
                if(this.modals.create.data.contract_id){
                    this.$store.dispatch('ServiveCategoryController/getServiceCategories', {
                        contractId: this.modals.create.data.contract_id,
                        categoryId: 0
                    }).then(response => {
                        this.modals.create.service_categorys = response;
                    });
                }
            },
            loadOptionServices({action, parentNode, callback}) {
                if (parentNode.isBatch) {
                    this.$store.dispatch("ServiveCategoryController/getServiceCategories", {
                        contractId: this.$route.params.id,
                        categoryId: parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback();
                    })
                } else {
                    callback();
                }
            },
            async getUserDetail(user_id) {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('v2UserController/getUser', user_id)
                    .then(response => { 
                        resolve(response.data.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
                });
                
            }
        }
    }
</script>